import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { RoundInfoResponse } from 'src/app/model/round-info-response.model';

@Component({
  selector: 'app-cartographie-mapbox',
  templateUrl: './cartographie-mapbox.component.html',
  styleUrls: ['./cartographie-mapbox.component.scss','./mapbox.css'], //mapbox.css for mapbox style
  encapsulation: ViewEncapsulation.None // allow modification of mapbox style]
})
export class CartographieMapboxComponent implements OnInit {

  map: mapboxgl.Map;
  @Input() accessToken: string;
  @Input() data: RoundInfoResponse;
  @Input() isTousFacteurAccounts: boolean=false;
  constructor() { }

  ngOnInit(): void {
   
    if (!this.isTousFacteurAccounts) {
        if (this.data && this.data.status[0].code=== "0") {
          let currentDelivery = this.data.currentDelivery;
          let pastDeliveries = new Array();
          this.data.round.forEach(element => {
            let pastDelivery = {
              latitude: element.latitude,
              longitude: element.longitude,
              timestamp: element.eventPassedMinutes,
            }
            pastDeliveries.push(pastDelivery);
          });

          //sorting by last position timestamp for mapbox
          pastDeliveries=pastDeliveries.sort((b,a) => b.timestamp - a.timestamp);
          let domicilePos:mapboxgl.LngLatLike;
          if (this.data.currentDelivery && this.data.currentDelivery.longitude && this.data.currentDelivery.latitude){

          domicilePos= [this.data.currentDelivery.longitude,this.data.currentDelivery.latitude];
          const lastRoundPos:mapboxgl.LngLatLike = [pastDeliveries[0].longitude,pastDeliveries[0].latitude ];
          let lastRoundPosTimeMinutes=pastDeliveries[0].timestamp;
          this.initMapbox(this.map,domicilePos,lastRoundPos,lastRoundPosTimeMinutes);
        }
        } else {
          // map config
        this.map = new mapboxgl.Map({
          container: 'map', // map container il faut le créer dans le html file :       <div id="map"></div>
          style: 'mapbox://styles/mapbox/streets-v8',
          center: [2.349014, 48.864716],//centre paris
          zoom: 8,
          maxZoom: 17,
          accessToken:this.accessToken 
             });
          this.showErrorPopup();
        }
      }
  }
  initMapbox(map:any,domicilePos:mapboxgl.LngLatLike,lastRoundPos:mapboxgl.LngLatLike,lastRoundPosTimeMinutes:number){
    // map config
        map = new mapboxgl.Map({
        container: 'map', // map container il faut le créer dans le html file :       <div id="map"></div>
        style: 'mapbox://styles/mapbox/streets-v8',
        center: domicilePos,//centre map to domicilePos
        zoom: 8,
        maxZoom: 17,
        accessToken:this.accessToken 
           });
      // Add map controls
      map.addControl(new mapboxgl.NavigationControl(), 'bottom-right'); 
      if (lastRoundPos !=null)
     
      map.on('load', () => this.getRoute(map,domicilePos,lastRoundPos,lastRoundPosTimeMinutes));
    }
    // create a function to make a directions request
     getRoute(map:any,domicilePos:mapboxgl.LngLatLike,lastRoundPos:mapboxgl.LngLatLike,lastRoundPosTimeMinutes:number) {
  // domicile icon
          const domicileElement = document.createElement('div');
          domicileElement.className = 'marker-domicile';
          domicileElement.style.backgroundImage = `url(assets/images/domicile@2x.png)`;
          domicileElement.style.width = `69px`;
          domicileElement.style.height = `47px`;
          domicileElement.style.backgroundRepeat='no-repeat'
          domicileElement.style.backgroundSize = 'contain';
          new mapboxgl.Marker(domicileElement)
          .setLngLat(domicilePos)
          .addTo(map);
              const positionPopup = this.findRelativePosition(lastRoundPos,
                domicilePos);
              // create the popup
              const popupLiv = new mapboxgl.Popup({
                offset: {
                'top': [0, 0],
                'top-left': [0, 0],
                'top-right': [0, 0],
                'bottom': [0, -50],
                'bottom-left': [0, 0],
                'bottom-right': [0, 0],
                'left': [0, 0],
                'right': [0, 0]
              },
                //anchor:positionPopup,
                closeButton: false,
                closeOnClick: false
              }).setHTML('<div>'+
             ' <table><tr><th><img src="assets/images/livraison-colissimo.svg" '+
             'class="imageInstantPosclass">'+
             '</th><th>&nbsp;</th><th><h3>Plus que quelques arrêts avant la livraison de votre colis </h3></th></tr></table></div>');
              // Create a default Marker, colored black
              const instantPosMarker = new mapboxgl.Marker({ color: 'black'})
              .setLngLat(lastRoundPos).setPopup(popupLiv).addTo(map).togglePopup();
              const markerDiv = instantPosMarker.getElement();
              const bounds= new mapboxgl.LngLatBounds(domicilePos,lastRoundPos);
              map.fitBounds(bounds, {});
            }
            showErrorPopup() {
			
              //block drag
              this.map.dragPan.disable();
               document.getElementById("error-message").innerHTML = "Le service de localisation est actuellement indisponible. Nous vous invitons à réessayer ultérieurement.";
                document.getElementById('error-message').style.display = 'block'; // Display error message
            }

            findRelativePosition(coord1: any, coord2: any) {
              // Define your criteria for right, left, top, or between
              const latitudeThreshold = 0.01; // Adjust as needed
              const longitudeThreshold = 0.0002; // Adjust as needed
              const [lat2,lon2] = coord2;
              const [lat1,lon1] = coord1;
              if (Math.abs(lat1 - lat2) <= latitudeThreshold) {
                if (lon1 - lon2 <= longitudeThreshold) {
                  return "top";
                } 	
                if (Math.abs(lon2 - lon1)  <= longitudeThreshold) {
                  return "";
                }
                    }
                    
                    
              return "";
            }
}
